// extracted by mini-css-extract-plugin
export var box = "order-details-box-module--box--oT2T7";
export var flexGrow = "order-details-box-module--flex-grow--s8m98";
export var titleText = "order-details-box-module--title-text--3tlGc";